export enum UpdateStatusLabels {
    dealer_id = 'dealer_id',
    done = 'done',
    progress = 'progress',
    queue = 'queue',
    spa_guid = 'spa_guid',
    success = 'success',
    timestamp = 'timestamp',
    type = 'type',
}